import {join} from 'ramda';
export const concatString = (spec:any,data:any) =>{
   return join(spec,data)
}